import { useState, useEffect } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { AcquisitionRun } from "models/acquisition-import";
import { useAuth } from "src/contexts/AuthContext";

export const useAcquisitionRun = (acquisitionId: string, runId: string) => {
  const [run, setRun] = useState<AcquisitionRun | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const fetchRun = async (silent = false) => {
    if (!silent) setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(
        `${API_URL}/acquisition-imports/${acquisitionId}/runs/${runId}`,
        { method: "GET" }
      );
      setRun(await checkResponse(response));
    } catch (err) {
      console.error("Error fetching acquisition run:", err);
      setError("Failed to fetch stage run.");
    } finally {
      if (!silent) setLoading(false);
    }
  };

  useEffect(() => {
    if (acquisitionId && runId) {
      fetchRun();
    }
  }, [acquisitionId, runId]);

  return {
    run,
    loading,
    error,
    refetch: (silent?: boolean) => fetchRun(silent),
  };
};
